import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../../models';

/** Representa o Filter da pesquisa dos recursos de campanhas */
export class RecursoCampanhaFilter implements Filter {
    isFilterDirty = false;

    filterPsq: string;
    tipos: number[] = [];;
    idsAreas: number[] = [];;
    situacoes: number[] = [];;
    idsPacotesCampanhas: number[] = [];;

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }

        // Tipos
        this.tipos?.forEach(tipo => {
            params = params.append('tipo', tipo.toString());
        });

        // Áreas
        this.idsAreas?.forEach(idArea => {
            params = params.append('idArea', idArea.toString());
        });

        // Situação
        this.situacoes?.forEach(situacao => {
            params = params.append('situacao', situacao.toString());
        });

        // Pacotes Campanhas
        this.idsPacotesCampanhas?.forEach(idPacoteCampanha => {
            params = params.append('idPacoteCampanha', idPacoteCampanha.toString());
        });

        return params;
    }

    clear() {
        this.isFilterDirty = false;

        this.filterPsq = null;
        this.tipos = [];
        this.idsAreas = [];
        this.situacoes = [];
        this.idsPacotesCampanhas = [];
    }
}

